import { AxiosError } from "axios";

export interface ApiError {
  error?: string;
  message?: string;
  details?: Record<string, string>;
  timestamp?: string;
}

export const extractErrorMessage = (
  error: unknown,
  defaultMessage: string = "Erro inesperado"
): string => {
  // Se for um erro do Axios
  if ((error as AxiosError).isAxiosError) {
    const axiosError = error as AxiosError<ApiError>;

    const apiError = axiosError.response?.data;

    if (apiError?.message) {
      return apiError.message;
    }

    if (apiError?.error) {
      const errorMessages: Record<string, string> = {
        EMAIL_ALREADY_EXISTS:
          "Este email já está sendo usado por outro usuário",
        USER_NOT_FOUND: "Usuário não encontrado",
        INVALID_CREDENTIALS: "Email ou senha incorretos",
        INVALID_PASSWORD: "Senha atual incorreta",
        UNAUTHORIZED: "Você não tem permissão para realizar esta ação",
        CNPJ_ALREADY_EXISTS: "Este CNPJ já está cadastrado",
        COMPANY_NOT_FOUND: "Empresa não encontrada",
        COMPANY_NAME_CONFLICT: "Nome da empresa já existe",
        SCHEMA_CREATION_ERROR: "Erro ao configurar estrutura da empresa",
        VALIDATION_ERROR: "Dados inválidos. Verifique os campos preenchidos",
        DATA_INTEGRITY_ERROR: "Erro de integridade dos dados",
        INTERNAL_ERROR: "Erro interno do servidor",
        NOT_FOUND: "Recurso não encontrado",
        FORBIDDEN: "Acesso negado",
      };

      return (
        errorMessages[apiError.error] || apiError.message || defaultMessage
      );
    }

    // Status HTTP
    const statusMessages: Record<number, string> = {
      400: "Dados inválidos enviados",
      401: "Não autorizado. Faça login novamente",
      403: "Acesso negado",
      404: "Recurso não encontrado",
      409: "Conflito de dados",
      422: "Dados não processáveis",
      429: "Muitas tentativas. Tente novamente mais tarde",
      500: "Erro interno do servidor",
      502: "Servidor indisponível",
      503: "Serviço temporariamente indisponível",
    };

    const status = axiosError.response?.status;
    if (status && statusMessages[status]) {
      return statusMessages[status];
    }

    if (axiosError.code === "ECONNABORTED") {
      return "Tempo limite excedido. Tente novamente";
    }

    if (axiosError.message?.includes("Network Error")) {
      return "Erro de conexão. Verifique sua internet";
    }

    if (axiosError.message) {
      return axiosError.message;
    }
  }

  return defaultMessage;
};

export const useErrorHandler = () => {
  return {
    extractErrorMessage,
    handleError: (error: unknown, defaultMessage?: string) => {
      const message = extractErrorMessage(error, defaultMessage);
      console.error("❌ Erro tratado:", message);
      return message;
    },
  };
};
